module.exports = __webpack_public_path__ + "static/img/Jack-Whitlock.5e0c40d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack-Whitlock.jpg
// module id = 539g
// module chunks = 0